import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { tap } from 'rxjs/operators';
import { AppService } from 'src/app/@service/app.service';
import Swal from 'sweetalert2';

interface Plan {
  response: {
    text_1753252798908_50663: string;
    dropdown_1753278552800_61101: string;
    number_1753252916954_68847: number;
  };
  used: boolean;
}

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
  constructor(
    private _appService: AppService,
    private _activatedRoute: ActivatedRoute
  ) { }

  studentCount: number = 1000;
  teacherCount: number = 30;
  plans: Plan[] = [];

  // ngOnInit(): void {
  //   this._activatedRoute.data.subscribe((data: any) => {
  //     console.log(data);
  //     this.plans = data.apiData.responses.map((response: any) => ({
  //       ...response,
  //       used: false
  //     }));
      
  //   });
  // }

  ngOnInit(): void {
  this._activatedRoute.data.subscribe((data: any) => {
    this.plans = data.apiData.responses.map((response: any) => ({
      ...response,
      used: true
    }));

    // // Custom sort order
    // const order:any = {
    //   "Static": 1,
    //   "Staff Based": 2,
    //   "Student Based": 3
    // };

    // this.plans.sort((a: any, b: any) => {
    //   const typeA = order[a.response.dropdown_1753278552800_61101] || 999;
    //   const typeB = order[b.response.dropdown_1753278552800_61101] || 999;
    //   return typeA - typeB;
    // });

    // Sort by position_at (1 → 9)
    this.plans.sort((a: any, b: any) => {
      const posA = a.response.position_at ?? 999;
      const posB = b.response.position_at ?? 999;
      return posA - posB;
    });

  });
}


  onCheckboxChange(plan: Plan): void {
    plan.used = !plan.used;
    this.calculateTotals(); // Trigger total recalculation
  }

  onStudentCountChange(): void {
    this.calculateTotals(); // Recalculate totals when student count changes
  }

  onTeacherCountChange(): void {
    this.calculateTotals(); // Recalculate totals when teacher count changes
  }

  private calculateTotals(): void {
    // This method ensures totals are updated whenever counts or checkboxes change
    // It's called from both checkbox and input change events
  }

  getIndStudentTotal(): number {
  return this.plans
    .filter(plan =>
      plan.response.dropdown_1753278552800_61101 === 'Student Based' && plan.used
    )
    .reduce((total, plan) =>
      total + Number(plan.response.number_1753252916954_68847), 0
    );
}

  getStudentTotal(): number {
    return this.plans
      .filter((plan: any) => plan.response.dropdown_1753278552800_61101 === 'Student Based' && plan.used)
      .reduce((total, plan) =>
        total + (plan.response.number_1753252916954_68847 * this.studentCount), 0
      );
  }

  getTeacherTotal(): number {
    return this.plans
      .filter(plan => (plan.response.dropdown_1753278552800_61101 === 'Teacher Based' || plan.response.dropdown_1753278552800_61101 === 'Staff Based') && plan.used)
      .reduce((total, plan) =>
        total + (plan.response.number_1753252916954_68847 * this.teacherCount), 0
      );
  }

  getStaticTotal(): number {
    return this.plans
      .filter(plan => plan.response.dropdown_1753278552800_61101 === 'Static' && plan.used)
      .reduce((total, plan) =>
        total + Number(plan.response.number_1753252916954_68847), 0
      );
  }

  getGrandTotal(): number {
    return this.getStudentTotal() + this.getTeacherTotal() + this.getStaticTotal();
  }

}